module.exports = __webpack_public_path__ + "img/side_whats_app.872afd75.png";